/**
 * Widget figli categoria (dinamico)
 * Cerca i container con data-json-url e data-collection-handle,
 * fetcha il JSON, filtra i figli per handle e renderizza link + icone.
 * Se data-icon-base-url è impostato usa le icone dal CDN (proxy/images);
 * altrimenti le icone sono negli assets del tema (data-sample-asset-url).
 */
(function () {
  function getIconUrl(iconBaseUrl, sampleAssetUrl, iconFilename) {
    if (!iconFilename) return '';
    if (iconBaseUrl && iconBaseUrl.trim()) {
      var base = iconBaseUrl.trim();
      if (base.charAt(base.length - 1) !== '/') base += '/';
      return base + encodeURIComponent(iconFilename);
    }
    if (!sampleAssetUrl) return '';
    try {
      var url = sampleAssetUrl.trim();
      var query = url.indexOf('?') >= 0 ? url.substring(url.indexOf('?')) : '';
      var pathPart = url.indexOf('?') >= 0 ? url.substring(0, url.indexOf('?')) : url;
      var lastSlash = pathPart.lastIndexOf('/');
      if (lastSlash < 0) return '';
      var base = pathPart.slice(0, lastSlash + 1);
      return base + encodeURIComponent(iconFilename) + query;
    } catch (e) {
      return '';
    }
  }

  function escapeHtml(s) {
    if (s == null) return '';
    var div = document.createElement('div');
    div.textContent = s;
    return div.innerHTML;
  }

  function renderWidget(container, children, iconBaseUrl, sampleAssetUrl, heading) {
    if (!children || children.length === 0) {
      container.style.display = 'none';
      return;
    }
    var list = document.createElement('ul');
    list.className = 'category-children-widget__list';
    children.forEach(function (child) {
      var li = document.createElement('li');
      li.className = 'category-children-widget__item';
      var a = document.createElement('a');
      a.href = child.link || '#';
      a.className = 'category-children-widget__link';
      var iconWrap = document.createElement('span');
      iconWrap.className = 'category-children-widget__icon-wrap';
      if (child.icon_asset && (iconBaseUrl || sampleAssetUrl)) {
        var imgSrc = getIconUrl(iconBaseUrl, sampleAssetUrl, child.icon_asset);
        if (imgSrc) {
          var img = document.createElement('img');
          img.src = imgSrc;
          img.alt = escapeHtml(child.titolo);
          img.loading = 'lazy';
          img.className = 'category-children-widget__icon';
          img.onerror = function () { this.style.display = 'none'; };
          iconWrap.appendChild(img);
        }
      }
      a.appendChild(iconWrap);
      var label = document.createElement('span');
      label.className = 'category-children-widget__label';
      label.textContent = child.titolo || '';
      a.appendChild(label);
      li.appendChild(a);
      if (child.collection_id) {
        var meta = document.createElement('meta');
        meta.setAttribute('itemprop', 'collection_id');
        meta.content = String(child.collection_id);
        li.appendChild(meta);
      }
      list.appendChild(li);
    });
    var inner = container.querySelector('.category-children-widget__inner') || container;
    inner.innerHTML = '';
    if (heading) {
      var h2 = document.createElement('h2');
      h2.className = 'category-children-widget__heading';
      h2.textContent = heading;
      inner.appendChild(h2);
    }
    inner.appendChild(list);
  }

  function init() {
    var widgets = document.querySelectorAll('.category-children-widget--dynamic[data-json-url][data-collection-handle]');
    widgets.forEach(function (container) {
      var jsonUrl = container.getAttribute('data-json-url');
      var handle = container.getAttribute('data-collection-handle');
      var heading = container.getAttribute('data-heading') || '';
      var iconBaseUrl = container.getAttribute('data-icon-base-url') || '';
      var sampleAssetUrl = container.getAttribute('data-sample-asset-url');
      if (!jsonUrl || !handle) return;
      fetch(jsonUrl, { credentials: 'omit' })
        .then(function (res) { return res.ok ? res.json() : Promise.reject(new Error('JSON non disponibile')); })
        .then(function (data) {
          var children = data[handle] || null;
          renderWidget(container, children, iconBaseUrl, sampleAssetUrl, heading);
          if (container.getAttribute('data-move-under-main-title') === 'true') {
            moveWidgetUnderMainTitle(container);
          }
        })
        .catch(function () {
          container.style.display = 'none';
        });
    });
  }

  function moveWidgetUnderMainTitle(container) {
    var bannerContent = document.querySelector('.yv-collection-banner .collection-banner-content') || document.querySelector('.collection-banner-content');
    if (!bannerContent) return;
    var h1 = bannerContent.querySelector('.collection-banner-title, h1');
    if (!h1) return;
    var widgetSection = container.closest('section');
    if (!widgetSection) return;
    bannerContent.insertBefore(widgetSection, h1.nextSibling);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
